import { Button } from '@shared/components/ui/button';
import { faFileArrowDown } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useToast } from '@shared/hooks/use-toast';
import { useTranslation } from 'react-i18next';
import { useWalletAccountingSyncExport } from '../../hooks';
import type { AccountingSyncStatus } from '../../models';

interface Props {
  statusFilter: AccountingSyncStatus | 'all';
}

export const ExportAccountingSyncCsvButton = ({ statusFilter }: Props) => {
  const { t } = useTranslation('accountingSyncModule');
  const { toast } = useToast();
  const exportMutation = useWalletAccountingSyncExport();

  const handleDownload = () => {
    exportMutation.mutate(
      {
        ...(statusFilter !== 'all' ? { status: statusFilter } : {}),
      },
      {
        onSuccess: ({ blob, filename }) => {
          const url = URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = filename;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          URL.revokeObjectURL(url);
          toast({
            title: t('export.success_title'),
            description: t('export.success_description'),
          });
        },
        onError: (error: Error) => {
          toast({
            title: t('export.error_title'),
            description: error?.message ?? t('export.error_description'),
            variant: 'destructive',
          });
        },
      },
    );
  };

  return (
    <Button
      type="button"
      size="default"
      variant="outline"
      onClick={handleDownload}
      disabled={exportMutation.isPending}
      className="gap-2 border-card-border bg-card-bg hover:bg-hover-press"
      data-testid="accounting-sync-export-csv"
    >
      <FontAwesomeIcon icon={faFileArrowDown} className="w-4 h-4 text-icons" />
      {t('export.button')}
    </Button>
  );
};
